import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

// ✅ IMAGES
import doctorImage from "../assets/dr-naveen-kumar.jpg";
import doctorTejesh from "../assets/dr-tejeswarao.jpg";
import doctorLokesh from "../assets/dr-lokesh.jpg";
import doctorVenkat from "../assets/dr-venkat-bhaskar.jpg";
import doctorSushma from "../assets/dr-sushma.jpg";
import doctorShiva from "../assets/dr-shiva-kumar.jpg";

const Doctors = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.toLowerCase();

  // ✅ DOCTORS DATA
  const doctors = [
    { id: 1, name: "Dr A Naveen Kumar", qualifications: "DNB General Surgeon", experience: "14 YEARS EXPERIENCE", rating: "5/5", speciality: "General Surgery & Advanced Laparoscopic Surgeon", location: "Visakhapatnam (Vizag)", phone: "9493994244", image: doctorImage },
    { id: 2, name: "Dr B Tejeswarao", qualifications: "MS General Surgeon", experience: "15 YEARS EXPERIENCE", rating: "4.9/5", speciality: "General Surgery & Laparoscopic Surgery", location: "Visakhapatnam (Vizag)", phone: "9493994244", image: doctorTejesh },
    { id: 3, name: "Dr B Lokesh", qualifications: "MS, MCH Gastro Surgeon", experience: "12 YEARS EXPERIENCE", rating: "4.9/5", speciality: "Gastrointestinal & Liver Surgery", location: "Visakhapatnam (Vizag)", phone: "9493994244", image: doctorLokesh },
    { id: 4, name: "Dr B Jognedhra", qualifications: "MS General Surgeon", experience: "13 YEARS EXPERIENCE", rating: "4.8/5", speciality: "General Surgery", location: "Visakhapatnam (Vizag)", phone: "9493994244", image: doctorVenkat },
    { id: 5, name: "Dr VJ Sushma", qualifications: "MS Plastic Surgeon", experience: "10 YEARS EXPERIENCE", rating: "4.9/5", speciality: "Plastic Surgery", location: "Visakhapatnam (Vizag)", phone: "9493994244", image: doctorSushma },
    { id: 6, name: "Dr Shiva Kumar", qualifications: "MS General Surgeon", experience: "12 YEARS EXPERIENCE", rating: "4.9/5", speciality: "General Surgery", location: "Hyderabad", phone: "9493994244", image: doctorShiva }
  ];

  // 🔥 FULL MAPPING (UNCHANGED)
  const doctorMapping = {

    // PROCTOLOGY
    piles: [1, 3],
    fissure: [1, 3],
    fistula: [1, 3],

    // LAPAROSCOPY
    hernia: [2, 4],
    femoral: [2, 4],
    incisional: [2, 4],
    hiatal: [2, 4],
    umbilical: [2, 4],
    inguinal: [2, 4],
    appendicitis: [2, 4],
    hysterectomy: [2, 4],

    // UROLOGY
    circumcision: [1, 4],
    stapler: [1, 4],
    laser: [1, 4],
    phimosis: [1, 4],
    balanoposthitis: [1, 4],
    pcnl: [1, 4],
    rirs: [1, 4],
    ursl: [1, 4],
    hydrocele: [1, 4],
    prostate: [1, 4],
    frenuloplasty: [1, 4],
    kidney: [1, 4],
    foreskin: [1, 4],

    // GYNECOLOGY
    mtp: [2, 4],
    pcod: [2, 4],
    pcos: [2, 4],

    // AESTHETICS
    gynecomastia: [5, 3],
    lipoma: [5, 3],

    // ENT
    turbinate: [1, 5],
    nasal: [1, 5],
    vocal: [1, 5],
    ear: [1, 5],
    throat: [1, 5],
    myringotomy: [1, 5],
    stapedectomy: [1, 5],
    tonsillectomy: [1, 5],
    thyroidectomy: [1, 5],
    fess: [1, 5],
    mastoidectomy: [1, 5],
    septoplasty: [1, 5],
    sinus: [1, 5],

    // FERTILITY
    iui: [3, 6],
    ivf: [3, 6],
    male: [3, 6],
    female: [3, 6],
    egg: [3, 6],

    // ORTHOPEDICS
    knee: [4, 2],
    shoulder: [4, 2],
    arthroscopy: [4, 2],
    rotator: [4, 2],
    meniscus: [4, 2],
    acl: [4, 2],
    carpal: [4, 2],

    // WEIGHT LOSS
    bariatric: [6, 5],

    default: [1, 2]
  };

  // ✅ FINAL LOGIC (MAIN + SUB SUPPORT)
  const getDoctorsByRoute = () => {

    // 🔥 MAIN CATEGORY PRIORITY
    if (path.includes("proctology")) return [1, 3];
    if (path.includes("laparoscopy")) return [2, 4];
    if (path.includes("urology")) return [1, 4];
    if (path.includes("gynecology")) return [2, 4];
    if (path.includes("aesthetics")) return [5, 3];
    if (path.includes("ent")) return [1, 5];
    if (path.includes("fertility")) return [3, 6];
    if (path.includes("orthopedics") || path.includes("ortho")) return [4, 2];
    if (path.includes("weight")) return [6, 5];

    // 🔥 SUB TITLE MATCH
    for (let key in doctorMapping) {
      if (path.includes(key)) {
        return doctorMapping[key];
      }
    }

    return doctorMapping.default;
  };

  const selectedIds = getDoctorsByRoute();

  const selectedDoctors = doctors.filter(doc =>
    selectedIds.includes(doc.id)
  );

  const handleCallDoctor = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  return (
    <>
      <style>{`
        .doctors-section {
          padding: 40px 20px;
          background: #f5f5f7;
        }

        .doctors-container {
          max-width: 1100px;
          margin: auto;
        }

        .title {
          text-align: center;
          font-size: 26px;
          font-weight: 700;
          color: #7D008D;
          margin-bottom: 30px;
        }

        .doctor-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
        }

        .doctor-card {
          background: #fff;
          border-radius: 18px;
          padding: 22px;
          border: 2px solid #eee;
          min-height: 420px;
          transition: 0.3s;
        }

        .active-card {
          border: 2px solid #7D008D;
        }

        .doctor-card:hover {
          border-color: #7D008D;
          box-shadow: 0 5px 15px rgba(0,0,0,0.08);
        }

        .doctor-top {
          display: flex;
          gap: 15px;
          align-items: center;
        }

        .doctor-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
        }

        .doctor-name {
          font-size: 18px;
          font-weight: 700;
          color: #7D008D;
        }

        .doctor-degree {
          font-size: 14px;
          color: #555;
        }

        .badge {
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 11px;
          margin-top: 6px;
          display: inline-block;
          margin-right: 5px;
        }

        .exp {
          background: #f3e6f7;
          color: #7D008D;
        }

        .free {
          background: #fff3e6;
          color: #FF7A00;
        }

        .rating {
          margin-top: 6px;
          font-size: 14px;
        }

        .divider {
          margin: 15px 0;
          border-top: 1px solid #eee;
        }

        .label {
          font-weight: 600;
          font-size: 14px;
        }

        .call-btn {
          width: 100%;
          padding: 12px;
          border: 2px solid #7D008D;
          color: #7D008D;
          border-radius: 12px;
          background: white;
          margin-top: 15px;
          cursor: pointer;
          font-weight: 600;
        }

        .book-btn {
          width: 100%;
          padding: 12px;
          background: #ff7a00;
          color: white;
          border-radius: 12px;
          border: none;
          margin-top: 12px;
          cursor: pointer;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .doctor-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <section className="doctors-section">
        <div className="doctors-container">

          <h2 className="title">Our Best Doctors</h2>

          <div className="doctor-grid">

            {selectedDoctors.map((doctor, index) => (
              <div
                key={doctor.id}
                className={`doctor-card ${index === 1 ? "active-card" : ""}`}
              >

                <div className="doctor-top">
                  <img src={doctor.image} className="doctor-img" />

                  <div>
                    <div className="doctor-name">{doctor.name}</div>
                    <div className="doctor-degree">{doctor.qualifications}</div>

                    <div>
                      <span className="badge exp">{doctor.experience}</span>
                      <span className="badge free">FREE CONSULTATION</span>
                    </div>

                    <div className="rating">⭐⭐⭐⭐⭐ {doctor.rating}</div>
                  </div>
                </div>

                <div className="divider"></div>

                <div>
                  <div className="label">Speciality</div>
                  <div>{doctor.speciality}</div>
                </div>

                <br/>

                <div>
                  <div className="label">Location</div>
                  <div>{doctor.location}</div>
                </div>

                <button
                  className="call-btn"
                  onClick={() => handleCallDoctor(doctor.phone)}
                >
                  📞 Call us {doctor.phone}
                </button>

                <button
                  className="book-btn"
                  onClick={() => {
                    navigate("/consultation");
                    window.scrollTo(0, 0);
                  }}
                >
                  Book Free Appointment
                </button>

              </div>
            ))}

          </div>

        </div>
      </section>
    </>
  );
};

export default Doctors;